export const FILTER_OPTIONS_REQUEST = 'FILTER_OPTIONS_REQUEST';
export const FILTER_OPTIONS_SUCCESS = 'FILTER_OPTIONS_SUCCESS';
export const FILTER_OPTIONS_FAIL = 'FILTER_OPTIONS_FAIL';
